import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";



import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import FormProvider from '../../../FunctionalComponent/FormElement/FormProvider';
import RHFTextField from '../../../FunctionalComponent/FormElement/RHTextField';
import { yupResolver } from '@hookform/resolvers/yup';
import { useChangePasswordMutation } from '../../../Redux/auth/authApi';
import { toast } from 'react-toastify';

const stepOneSchema = Yup.object().shape({
    password: Yup.string().required("Please Enter Your Password").matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/, "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"),
    confirmPassword: Yup.string().required("Please Enter Your Confirm Password").oneOf([Yup.ref('password')], 'Passwords must match'),
    oldPassword: Yup.string().required("Please Enter Your Old Password")
});

const validateWith = {
    shouldDirty: true,
    shouldTouch: true,
    shouldValidate: true,
}


const ChangePassword = () => {

    const [passwordRestFn, { isLoading, isSuccess, error, data }] = useChangePasswordMutation()

    const defaultValues = {
        password: '',
        confirmPassword: '',



    };


    const methods = useForm({
        resolver: yupResolver(stepOneSchema),
        defaultValues,
        mode: 'all',
    });

    const {
        reset,
        setError,
        setValue,
        handleSubmit,
        getValues,
        formState: { errors },
    } = methods;

    const onSubmit = async (data) => {
        try {

            passwordRestFn(data)


        } catch (error) {

            setError("afterSubmit", {
                ...error,
                message: error.message,
            });
        }
    };

    const dispatch = useDispatch()


    const [passwordShow, setPasswordShow] = useState(false);
    const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);

    useEffect(() => {
        if (isSuccess) {
            const message = data?.message || "Product created successfully";
            toast.success(message);
            reset()



        }
        if (error) {
            if ('data' in error) {
                const errorData = error;
                toast.error(errorData.data.message);

            }
        }
    }, [data, isSuccess, error]);


    return (
        <React.Fragment>
            <Row>
                <Col lg={4}>
                    <h5 className="fs-16">Change Password</h5>
                    <p className="text-muted mb-lg-0">Personal Identifiable Information (PII) is defined as representation of information that permits the identity of an individual to whom the information applies to be reasonably inferred by either direct or indirect means.</p>
                </Col>
                <Col lg={8}>
                    <Card>
                        <Card.Body>
                            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>

                                <Row className="g-3">
                                    <Col lg={4}>
                                        <div>
                                            {/* <Form>
                                                <Form.Label htmlFor="oldPassword">Old Password*</Form.Label>
                                                <Form.Control type="password" id="oldPassword" placeholder="Enter current password" autoComplete='off' />
                                            </Form> */}

                                            <RHFTextField name='oldPassword' label='Old Password' required />

                                        </div>
                                    </Col>
                                    <Col lg={4}>
                                        {/* <Form> */}

                                        <div className="position-relative auth-pass-inputgroup">


                                            <RHFTextField type={passwordShow ? "text" : "password"} name='password' label='Password' required />
                                            <Button variant='link' style={{ marginTop: "28px" }} className="btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}>

                                                {!passwordShow ? <i class="ri-eye-off-line"></i> : <i class="ri-eye-line"></i>}
                                            </Button>
                                        </div>


                                    </Col>

                                    <Col lg={4}>

                                        <div className="position-relative auth-pass-inputgroup">


                                            <RHFTextField type={confirmPasswordShow ? "text" : "password"} name='confirmPassword' label='Confirm assword' required />
                                            <Button variant='link' style={{ marginTop: "28px" }} className="btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon" onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}>

                                                {!confirmPasswordShow ? <i class="ri-eye-off-line"></i> : <i class="ri-eye-line"></i>}
                                            </Button>
                                        </div>


                                    </Col>

                                    <Col lg={12}>
                                        {/* <div>
                                            <Link to="#" className="link-primary text-decoration-underline">Forgot Password ?</Link>
                                        </div> */}
                                    </Col>
                                    <Col lg={12}>
                                        <div className="text-end">
                                            <Button variant='success' type="submit">Change Password</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </FormProvider>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </React.Fragment >
    );
}

export default ChangePassword;
